import MessagingSidebar from './components/MessagingSidebar';
import React from 'react';
import MessageCanvas from './components/MessageCanvas';
import { useConversationContext } from './providers/ConversationProvider';

interface MessagingProps {
  pageType?: 'portfolio' | 'project';
}

const Messaging: React.FC<MessagingProps> = function() {
  const { inactiveConversations, activeConversations, supportConversations } = useConversationContext();
  const conversationLength = [...inactiveConversations, ...activeConversations, ...supportConversations]?.length ?? 0;


  return (
    <div style={{
      display: 'flex',
      justifyContent: 'space-between', 
    }}>
      {conversationLength > 1 && (
        <div style={{ marginRight: 'var(--medium)' }}>
          <MessagingSidebar />
        </div>
      )}
      <MessageCanvas />
    </div>
  );
};

export default Messaging;